import Long from 'long';
import { useEffect, useState } from 'react';
import { CaptionButton } from '~/shared/components/ui/Button';
import {
  FacilityDialog,
  FacilityFormOption,
} from '~/shared/components/ui/Dialog/FacilityDialog';

import { error } from '~/shared/components';

export const UISampleFacilityDialogs = () => {
  const [confirmationResult, setConfirmationResult] = useState('');
  const [isConfirmationShow, setConfirmationShow] = useState(false);

  const [companyId, setCompanyId] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const res = await window.App.services.companyService.getCompany({});
        setCompanyId(res.companyId);
      } catch (err) {
        error(['自社企業取得に失敗しました']);
        throw err;
      }
    })();
  }, []);

  const inputOption: FacilityFormOption = {
    buFacilities: {
      companyId: companyId,
      categorys: [
        {
          categoryName: 'A4000003',
          code: '0',
          systemName: 'B00',
        },
      ],
      manufacture: 'テスト設備',
      modelNumber: 'AB0123',
      assetsAmount: Long.fromString('30'),
      accuracy: {
        categoryName: 'A4000004',
        code: '0',
        systemName: 'B00',
      },
      processableTon: Long.fromString('20'),
      sizeX: Long.fromString('3000'),
      sizeY: Long.fromString('40000'),
      sizeZ: Long.fromString('20000'),
      processableMaterial: {
        categoryName: 'A4000005',
        code: '0',
        systemName: 'B00',
      },
      remarks: 'テスト',
      skillRelations: [
        {
          materialItemId: 'AT040001',
          technologyItemId: 'AT020001',
        },
        {
          materialItemId: 'AT040012',
          technologyItemId: 'AT020013',
        },
      ],
    },
  };

  return (
    <div className="categories">
      <h3 id="dialog">設備確認ダイアログ</h3>

      <div className="input-line">
        <div className="item-group-100">
          <div className="w-33">
            <CaptionButton
              buttonType="basic"
              caption="確認する"
              name=""
              onClick={() => {
                setConfirmationResult('');
                setConfirmationShow(true);
              }}
            />
            <FacilityDialog
              isOpen={isConfirmationShow}
              inputOption={inputOption}
              onCancel={() => {
                setConfirmationResult('キャンセルしました');
                setConfirmationShow(false);
              }}
            />
          </div>
          <div className="w-66">
            <pre className="output">{confirmationResult}</pre>
          </div>
        </div>
      </div>
    </div>
  );
};
